var map = {
	"./teach0.png": "FzNW",
	"./teach1.png": "Ha6g",
	"./teach2.png": "PH3H",
	"./teach3.png": "rpQd"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "hfPR";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/upiTeaching ^\.\/teach.*\.png$
// module id = hfPR
// module chunks = 0